"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useId } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
export default function Smoke(t0) {
  const $ = _c(27);
  const {
    inverse: t1,
    isActive: t2
  } = t0;
  const inverse = t1 === undefined ? false : t1;
  const isActive = t2 === undefined ? false : t2;
  const [init, setInit] = useState(false);
  const t3 = useId();
  let t4;
  if ($[0] !== t3) {
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = /:/g;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    t4 = t3.replace(t5, "");
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const id = t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      initParticlesEngine(_temp).then(() => {
        setInit(true);
      });
    };
    t6 = [];
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  if (!init) {
    return null;
  }
  const t7 = `absolute inset-[-20%] z-0 pointer-events-none blur-[6px] transition-opacity duration-500
      ${inverse ? "mix-blend-multiply" : "mix-blend-screen"}
      ${isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`;
  const t8 = `smoke-${id}`;
  let t9;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      enable: false
    };
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      value: 30,
      density: {
        enable: true,
        width: 100,
        height: 100
      }
    };
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  const t11 = inverse ? "#000000" : "#ffffff";
  let t12;
  if ($[7] !== t11) {
    t12 = {
      value: t11
    };
    $[7] = t11;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  let t13;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      type: "circle"
    };
    $[9] = t13;
  } else {
    t13 = $[9];
  }
  const t14 = inverse ? 0.7 : 0.35;
  let t15;
  if ($[10] !== t14) {
    t15 = {
      min: 0.1,
      max: t14
    };
    $[10] = t14;
    $[11] = t15;
  } else {
    t15 = $[11];
  }
  let t16;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      enable: true,
      speed: 0.5,
      sync: false
    };
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  let t17;
  if ($[13] !== t15) {
    t17 = {
      value: t15,
      animation: t16
    };
    $[13] = t15;
    $[14] = t17;
  } else {
    t17 = $[14];
  }
  let t18;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      value: {
        min: 10,
        max: 40
      },
      animation: {
        enable: true,
        speed: 5,
        sync: false
      }
    };
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  let t19;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      min: 0.5,
      max: 2
    };
    $[16] = t19;
  } else {
    t19 = $[16];
  }
  let t20;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      enable: true,
      speed: t19,
      direction: "top",
      random: true,
      straight: false,
      outModes: {
        default: "out"
      }
    };
    $[17] = t20;
  } else {
    t20 = $[17];
  }
  let t21;
  if ($[18] !== t12 || $[19] !== t17) {
    t21 = {
      fullScreen: t9,
      fpsLimit: 60,
      particles: {
        number: t10,
        color: t12,
        shape: t13,
        opacity: t17,
        size: t18,
        move: t20
      }
    };
    $[18] = t12;
    $[19] = t17;
    $[20] = t21;
  } else {
    t21 = $[20];
  }
  let t22;
  if ($[21] !== t21 || $[22] !== t8) {
    t22 = <Particles id={t8} options={t21} className="w-full h-full" />;
    $[21] = t21;
    $[22] = t8;
    $[23] = t22;
  } else {
    t22 = $[23];
  }
  let t23;
  if ($[24] !== t22 || $[25] !== t7) {
    t23 = <div className={t7}>{t22}</div>;
    $[24] = t22;
    $[25] = t7;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  return t23;
}
async function _temp(engine) {
  await loadSlim(engine);
}